import Resource from '@/api/resources/Resource'

class CommonRequestService extends Resource {
    async findByLabel(laboratoryId, requestLabel) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/requests/${requestLabel}/findByLabel`)
        return response.data
    }

    async getTracking(laboratoryId, requestId) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/requests/${requestId}/tracking`)
        return response.data
    }

    async getRequestByIdForSidePanel(laboratoryId, requestId) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/requests/${requestId}/sidePanel`)
        return response.data
    }

    async getRequestByCaseIdForSidePanel(laboratoryId, caseId) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/cases/${caseId}/request/sidePanel`)
        return response.data
    }

    async search(params) {
        const response = await this.axios.get('/common/requests/search', { params })
        return response.data
    }

    async isAutomaticallyGenerated(laboratoryId, requestLabel) {
        const response = await this.axios.get(`/common/laboratories/${laboratoryId}/request/${requestLabel}/isAutomaticallyGenerated`)
        return response.data
    }
}

export default new CommonRequestService()
